import { avatarsRef } from "@/core/config/firebase";
import { addImageProcess, dataURItoBlob } from "@/core/utils";


export const uploadProfileImage = async (uid, image) => {
  const imageRef = await avatarsRef.child(uid + '.jpeg');
  const data = await addImageProcess(image);
  const file = dataURItoBlob(data);
  await imageRef.put(file);
  return imageRef
}
